import "./AboutUs.css";

import { Outlet } from "react-router-dom";

export default function AboutUs(props){

    return <div className="container">
        <h1>About Us</h1>
        <div><Outlet /></div>
    </div>
}